import React, { useEffect } from "react";
import SmartTVContainer from "../containers/live/smartTV/SmartTVContainer";
import { requestPageFullscreen } from "../hooks/usePageFullscreen";

const WebSmartTVPage = ({ ...props }) => {
    useEffect(() => {
        requestPageFullscreen(); // 260803 로그인 후 SmartTV 화면 진입 시 가능한 브라우저에서는 즉시 전체화면으로 전환한다.
    }, []);

    return (
        <SmartTVContainer {...props} />
    );
};

export default WebSmartTVPage;
